import React, { Component } from "react";
import Flag from "react-world-flags";
import { CountryMetric } from "../../../../generated";
import { Select } from "antd";

export class CountryListItem extends Component<
  {
    selected: string;
    value: CountryMetric;
  },
  {}
> {
  render() {
    return (
      <>
        <Flag
          code={this.props.value.countryCode}
          alt={this.props.value.countryCode}
          width="25px"
          height="18px"
        />
        &nbsp;
        {this.props.value.name}
      </>
    );
  }
}

export class CountryList extends Component<
  {
    countries: CountryMetric[];
    selectedElement: string;
    handleListItemClick: (countryCode: string) => void;
  },
  {}
> {
  render() {
    return (
      <div>
        <Select
          onChange={this.props.handleListItemClick}
          value={this.props.selectedElement}
          className={"w-100"}
        >
          {this.props.countries.map((country) => (
            <Select.Option
              value={country.countryCode}
              key={country.countryCode}
            >
              <CountryListItem
                key={country.countryCode}
                value={country}
                selected={this.props.selectedElement}
              />
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}
